import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as CheckmarkCircle } from '../../../../assets/icons/checkmark-circle.svg'
import { ReactComponent as Cancel } from '../../../../assets/icons/close.svg'
import { ReactComponent as Earth } from '../../../../assets/icons/earth.svg'
import {
    ConditionNameEnum,
    ConditionTypeEnum,
    IResponseContent,
    useResponsesStore,
} from '../../../../stores/responsesStore'
import ResponseYaml from '../ResponseYaml/ResponseYaml'

import styles from './message.module.scss'

interface IEditMessageProps {
    message: IResponseContent
    setIsEditing: React.Dispatch<React.SetStateAction<boolean>>
}

function EditMessage(props: IEditMessageProps) {
    const { message, setIsEditing } = props

    const { t } = useTranslation()

    const inputRef = useRef<HTMLTextAreaElement>(null)

    const [, { editResponseContent }] = useResponsesStore()

    const [language, setLanguage] = useState(
        message?.condition?.find(
            (condition) => condition.name === ConditionNameEnum.LANGUAGE
        )?.value || ''
    )
    const [text, setText] = useState(message.text || '')

    useEffect(() => {
        if (inputRef?.current) {
            inputRef.current.focus()
        }
    }, [])

    useEffect(() => {
        setText(message.text || '')
        setLanguage(
            message?.condition?.find(
                (condition) => condition.name === ConditionNameEnum.LANGUAGE
            )?.value || ''
        )
    }, [message.text, message.condition])

    const handleSave = () => {
        editResponseContent({
            _id: message._id,
            text,
            condition: [
                {
                    name: ConditionNameEnum.LANGUAGE,
                    type: ConditionTypeEnum.SLOT,
                    value: language,
                },
            ],
            image: message.image,
        })
        setIsEditing(false)
    }

    const handleCancel = () => {
        setIsEditing(false)
    }

    return (
        <>
            <div className={styles.message__textAreaWrapper}>
                <textarea
                    ref={inputRef}
                    className={styles.message__input}
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                />
            </div>
            <div className={styles.message__buttons}>
                <div className={styles.message__language}>
                    <Earth className={styles.message__languageIcon} />
                    <input
                        className={styles.message__languageInput}
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                    />
                </div>
                <ResponseYaml message={message} />
                <button className={styles.message__btn} onClick={handleSave}>
                    <CheckmarkCircle
                        className={styles.message__icon}
                        alt={t('save')}
                    />
                </button>
                <button className={styles.message__btn} onClick={handleCancel}>
                    <Cancel
                        className={styles.message__icon}
                        alt={t('cancel')}
                    />
                </button>
            </div>
        </>
    )
}

export default EditMessage
